import styled from "styled-components";

export const UserStatusWithdrawalLimitsProgressCardStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    background: var(--color-fill-secondary);
    border-radius: 16px;
`;

interface UserStatusWithdrawalLimitsProgressCardStyledProps {
    percent: number,
}

export const UserStatusWithdrawalLimitsProgressCardLineStyled = styled.div<UserStatusWithdrawalLimitsProgressCardStyledProps>`
    height: 4px;
    border-radius: 2px;
    background: ${({ percent }) => `linear-gradient(90deg, var(--color-button-primary-default) ${percent}%, var(--color-fill-primary) ${percent}%, var(--color-fill-primary) 100%)`};
`;
